// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SpellingPracticeController from "./spelling_practice_controller"
application.register("spelling-practice", SpellingPracticeController)

import SpellingInputPracticeController from "./spelling_input_practice_controller"
application.register("spelling-input-practice", SpellingInputPracticeController)

import SpacedRepetitionController from "./spaced_repetition_controller"
application.register("spaced-repetition", SpacedRepetitionController)
